import { FeatureValue } from "./feature-value";
export class FeatureObject {
    constructor(
        public Key?: any,
        public SelectedOption?: any,
        public Values?: FeatureValue[]
    ) { }
}
